/* ==========================================================================
   Collection sort dropdown (templates/collection.liquid)

   Same behaviour as main-collection's .cg__select: a custom listbox that
   reorders the grid client-side, with letter dividers for A-Z / Z-A and the
   choice kept in ?sort= so a sorted page can be shared. Until an option is
   picked the toggle reads "Sort by" and the grid keeps the admin order.
   ========================================================================== */

(function () {
  'use strict';

  function init() {
    var control = document.querySelector('[data-collection-sort]');
    var grid = document.querySelector('[data-collection-grid]');
    if (!control || !grid || control.dataset.sortBound === 'true') return;
    control.dataset.sortBound = 'true';

    var toggle = control.querySelector('.collection-sort-toggle');
    var label = control.querySelector('.collection-sort-value');
    var list = control.querySelector('.collection-sort-list');
    var options = Array.prototype.slice.call(control.querySelectorAll('.collection-sort-option'));
    var items = Array.prototype.slice.call(grid.querySelectorAll('.collection-grid-item'));
    var sort = control.dataset.default;

    var compare = {
      'manual': function (a, b) { return Number(a.dataset.position) - Number(b.dataset.position); },
      'title-ascending': function (a, b) { return a.dataset.sortTitle.localeCompare(b.dataset.sortTitle); },
      'title-descending': function (a, b) { return b.dataset.sortTitle.localeCompare(a.dataset.sortTitle); },
      'date-descending': function (a, b) { return Number(b.dataset.release) - Number(a.dataset.release); },
      'date-ascending': function (a, b) { return Number(a.dataset.release) - Number(b.dataset.release); },
      'price-ascending': function (a, b) { return Number(a.dataset.price) - Number(b.dataset.price); },
      'price-descending': function (a, b) { return Number(b.dataset.price) - Number(a.dataset.price); }
    };

    function render() {
      var ordered = items.slice().sort(compare[sort] || compare.manual);
      var fragment = document.createDocumentFragment();
      var alpha = sort === 'title-ascending' || sort === 'title-descending';
      var last = null;

      ordered.forEach(function (item) {
        if (alpha) {
          var letter = (item.dataset.sortTitle.charAt(0) || '').toUpperCase();
          if (!/[A-Z]/.test(letter)) letter = '#';
          if (letter !== last && letter !== '#') {
            var divider = document.createElement('div');
            divider.className = 'collection-alpha';
            divider.textContent = letter;
            fragment.appendChild(divider);
          }
          last = letter;
        }
        fragment.appendChild(item);
      });

      grid.replaceChildren(fragment);
    }

    function select(option, apply) {
      options.forEach(function (o) { o.setAttribute('aria-selected', String(o === option)); });
      label.textContent = option.textContent;
      sort = option.dataset.value;
      if (!apply) return;

      render();
      var params = new URLSearchParams(window.location.search);
      if (sort === control.dataset.default) params.delete('sort');
      else params.set('sort', sort);
      var query = params.toString();
      history.replaceState(null, '', window.location.pathname + (query ? '?' + query : ''));
    }

    function open() {
      list.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      (control.querySelector('[aria-selected="true"]') || options[0]).focus();
    }

    function close(refocus) {
      list.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      if (refocus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (list.hidden) open(); else close(false);
    });

    toggle.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') { event.preventDefault(); open(); }
    });

    options.forEach(function (option, index) {
      option.addEventListener('click', function () { select(option, true); close(true); });
      option.addEventListener('keydown', function (event) {
        switch (event.key) {
          case 'ArrowDown': event.preventDefault(); options[Math.min(index + 1, options.length - 1)].focus(); break;
          case 'ArrowUp': event.preventDefault(); options[Math.max(index - 1, 0)].focus(); break;
          case 'Home': event.preventDefault(); options[0].focus(); break;
          case 'End': event.preventDefault(); options[options.length - 1].focus(); break;
          case 'Enter':
          case ' ': event.preventDefault(); select(option, true); close(true); break;
          case 'Escape': close(true); break;
          case 'Tab': close(false); break;
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!event.target.closest('[data-collection-sort]')) close(false);
    });

    // Open on the sort in the URL, if any.
    var requested = new URLSearchParams(window.location.search).get('sort');
    var initial = options.filter(function (o) { return o.dataset.value === requested; })[0];
    if (initial) {
      select(initial, false);
      render();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
